module.exports = __webpack_public_path__ + "static/media/gameFire.4f417c92.svg";